<div class="w-full h-[64px] px-6 box-border
            flex items-center justify-between
            rounded-t-2xl bg-blue-90">
  <span class="text-neutral-10 text-body-medium">{{ 'CONSENT.BANNER_TEXT' | translate }}</span>

  <div class="min-w-fit">
    <button mat-stroked-button
            class="mr-2"
            (click)="manageCookies()">{{ 'CONSENT.BANNER_LEARN_MORE' | translate }}</button>
    <button mat-flat-button
            class="mr-2"
            (click)="rejectCookies()">{{ 'CONSENT.BANNER_REJECT' | translate }}</button>
    <button mat-flat-button
            color="primary"
            (click)="acceptCookies()">{{ 'CONSENT.BANNER_ACCEPT' | translate }}</button>
  </div>

</div>
